// Client-mode avatar resolution — ONE rule for which store wins.
//
// A PRO's canonical photo lives on profiles.avatar_url: the barber/owner
// account page writes it there, and its upload flow DELETES the user's old
// avatar files from storage first — so any stale copy of the URL dies. The
// copy in auth user_metadata.avatar_url is only written by the client-account
// flows, so for a pro it can silently point at a deleted file, which is why
// pros in Client mode saw a broken avatar in the floating nav.
//
// A TRUE CLIENT has no profiles row — user_metadata IS their store.
export function resolveClientAvatar(opts: {
  hasProProfile: boolean
  profileAvatarUrl?: string | null
  metadataAvatarUrl?: string | null
}): string | null {
  const { hasProProfile, profileAvatarUrl, metadataAvatarUrl } = opts
  return hasProProfile ? profileAvatarUrl || null : metadataAvatarUrl || null
}
